/* eslint-disable no-undef */
import format from 'date-fns/format'
import isBefore from 'date-fns/isBefore'
import isSameDay from 'date-fns/isSameDay'
import subDays from 'date-fns/subDays'
import previousSunday from 'date-fns/previousSunday'
import startOfMonth from 'date-fns/startOfMonth'
import subMonths from 'date-fns/subMonths'
import startOfYear from 'date-fns/startOfYear'
import subYears from 'date-fns/subYears'
import { SCOPES } from './permissionsMap'

export const formatDate = (date) => format(new Date(date), 'MM/dd/yyyy')

export const dateIsBefore = (date1, date2) => isBefore(new Date(date1), new Date(date2))

export const daysAreSame = (date1, date2) => isSameDay(new Date(date1), new Date(date2))

export const getApiServer = () => {
  const { protocol, hostname } = window.location
  return hostname === 'localhost' ? 'http://localhost:5000/api' : `${protocol}//${hostname}/api`
}

export const getPercentIncrease = (startingValue, finalValue) => {
  if (finalValue === 0 && startingValue === 0) {
    return 0
  }
  
  return ((finalValue - startingValue) / Math.abs(startingValue)) * 100
}

export const formatPercentage = (percent) => {
  const percentage = percent.toFixed(1)
  const values = percentage.split('.')
  const sign = percent > 0 ? '+' : ''
  return `${sign}${values[1] === '0' ? values[0] : percentage}%` 
}

export const formatReportColumns = (report) => {
  if (!report) {
    return []
  }

  if (report.results.length === 0) {
    return []
  } 

  return Object.keys(report.results[0]).filter((key) => key.toLowerCase() !== 'id')
}

export const addAllOption = (options, allOption) => {
  return [allOption, ...options]
}


export const getReportScope = (id) => {
  switch (id) {
  case '1':
  case '7':
    return [SCOPES.canViewMainReport]
  case '2':
    return [SCOPES.canViewReport]
  case '3':
  case '4':
  case '5':
  case '6':
    return [SCOPES.canViewCOReports]
  default:
    return []
  }
}

export const filterOrganizations = (state, organizations) => {
  switch(state) {
  case 'All':
    return organizations
  case 'CO':
  case 'WI':
    return organizations.filter((org) => org.State && org.State.toLowerCase() === state.toLowerCase())
  case 'Other':
    return organizations.filter((org) => org.State && (org.State.toLowerCase() !== 'co' && org.State.toLowerCase() !== 'wi'))
  default:
    return organizations
  }
}

export const subtractDays = (date, span) => subDays(date, span)

export const getStartOfWeek = (date) => previousSunday(date)

export const getStartOfMonth = (date) => startOfMonth(date)

export const subtractMonths = (date, span) => subMonths(date, span)

export const getStartOfYear = (date) => startOfYear(date)

export const subtractYears = (date, span) => subYears(date, span)

export const getDateComparer = (dateToCompare, timeSpan) => {
  switch (timeSpan) {
  case 0: 
    return getStartOfWeek(dateToCompare)
  case 1: 
    return getStartOfMonth(dateToCompare)
  case 2: 
    return subtractMonths(getStartOfMonth(dateToCompare), 1)
  case 3: 
    return subtractMonths(getStartOfMonth(dateToCompare), 5)
  case 4:
    return getStartOfYear(dateToCompare)
  default:
    break
  }
}

export const a11yProps = (index) => {
  return {
    id: `kpi-tab-${index}`,
    'aria-controls': `kpi-tabpanel-${index}`
  }
}

export const isValidDate = (dateString) => {
  if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
    return false
  }

  // Parse the date parts to integers
  const parts = dateString.split('/')
  const day = parseInt(parts[1], 10)
  const month = parseInt(parts[0], 10)
  const year = parseInt(parts[2], 10)

  // Check the ranges of month and year
  if(year < 1000 || year > 3000 || month == 0 || month > 12)
    return false

  const monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ]

  // Adjust for leap years
  if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)) {
    monthLength[1] = 29
  }

  // Check the range of the day
  return day > 0 && day <= monthLength[month - 1]
}
